/**
 * @file report.ts
 * @description Сервис для генерации и получения отчетов в Task Manager. Обеспечивает создание различных типов отчетов по задачам, проектам и пользователям с возможностью фильтрации и настройки параметров отчетности.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import { TApiData } from '@src/types';
import { postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const ReportService = {
    /**
     * Получает список отчетов по указанному типу
     * @param {string} name - Название типа отчета для генерации
     * @param {TApiData} body - Параметры и фильтры для генерации отчета
     * @param {TApiData} params - Дополнительные параметры запроса отчета
     * @returns {Promise} Промис с данными сгенерированного отчета
     */
    getList: async (name: string, body?: TApiData, params?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`report/${name}`, body, params);
    }
};
